/* eslint-disable import/no-unused-modules */

/**
 * AssetSelectionStep Constants
 * Local constants for asset selection functionality
 */

// Asset selection configuration
export const ASSET_SELECTION_CONSTANTS = {
    // Wizard modes
    CREATE_MODE: 'create',
    EDIT_MODE: 'edit',

    // Page size for asset pagination
    PAGE_SIZE: 2000,

    // Default page number for API calls
    DEFAULT_PAGE_NUMBER: 1,

    // Virtualized list configuration
    ITEM_HEIGHT: 70, // Height of each list item in pixels
    LIST_HEIGHT: 400, // Height of the virtualized list container

    // Performance optimization
    OVERSCAN_COUNT: 5, // Number of items to render outside visible area

    // Search debounce timing
    SEARCH_DEBOUNCE_MS: 300
};

// Asset type string constants
export const ASSET_TYPE_STRINGS = {
    GENERIC_MACHINE: 'GenericMachine',
};

// Asset status constants
export const ASSET_STATUS = {
    SELECTED: 'Selected',
};

// Dialog type constants
export const DIALOG_TYPES = {
    UNSELECT: 'unselect',
    REMOVE_SUB_TYPE: 'removeSubType',
    CHANGE_SUB_TYPE: 'changeSubType',
};

// Default generic machine sub-type options
export const DEFAULT_GENERIC_MACHINE_SUB_TYPES = [
    { value: 'Bearing', label: 'Bearing', type: 'Bearing' },
    { value: 'Fan', label: 'Fan', type: 'Fan' },
    { value: 'Gearbox', label: 'Gearbox', type: 'Gearbox' },
    { value: 'Pump', label: 'Pump', type: 'Pump' },
];

// Asset selection UI constants
export const ASSET_SELECTION_UI = {
    // Icon sizes for asset items
    ICON_SIZES: {
        SMALL: { width: 16, height: 16 },
        MEDIUM: { width: 24, height: 24 },
        LARGE: { width: 32, height: 32 }
    },

    // List styling
    MAX_VISIBLE_ITEMS: 6,
    MIN_VISIBLE_ITEMS: 3
};
